import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuIcon from '@mui/icons-material/Menu';
import React, { useEffect, useRef, useState } from "react";
import Drawer from "@mui/material/Drawer";
import { PrivilegeValue, useAuthContext } from "../contexts/AuthContext";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";

import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from "@mui/material/ListItemAvatar";

import QrCodeIcon from '@mui/icons-material/QrCode';
import ShareIcon from '@mui/icons-material/Share';
import { constructCalendarUrlWithQuery, useEventContext } from "../contexts/EventContext";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, useTheme } from "@mui/material";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import { BootstrapDialog } from "./eventModal/EventModal";
import { DialogCloseButton } from "./shared/DialogCloseButton";
import { IconTextRow } from "./shared/IconTextRow";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { AuthenticationState } from "../monad/AuthenticationState";
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { useHttpClientContext } from "../contexts/HttpClientContext";
import { AxiosError } from "axios";

import CheckIcon from '@mui/icons-material/Check';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TodayIcon from '@mui/icons-material/Today';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import ViewDayOutlinedIcon from '@mui/icons-material/ViewDayOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { useTranslation } from 'react-i18next';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { ThemeModePreference, useThemeModeContext } from "../contexts/ThemeModeContext";

export const PCSAppBar = () => {

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isInformationDialogOpen, setIsInformationDialogOpen] = useState(false);

    const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false);
    const [isShareQrModalOpen, setIsShareQrModalOpen] = useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setIsDrawerOpen(newOpen);
    };

    const toggleQrCodeModal = (newOpen: boolean) => () => {
        setIsQrCodeModalOpen(newOpen);
    };

    const authContext = useAuthContext();
    const eventContext = useEventContext();
    const themeMode = useThemeModeContext();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const handleLanguageChange = (event: SelectChangeEvent) => {
        i18n.changeLanguage(event.target.value as string);
        localStorage.setItem('i18nextLng', event.target.value as string);
    };

    const handleThemeModeChange = (event: SelectChangeEvent) => {
        themeMode.setMode(event.target.value as ThemeModePreference);
    };

    return (
        <AppBar position="static">
            <Toolbar>
                {authContext.user.match({
                    loggedIn(_) {
                        return <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={() => setIsQrCodeModalOpen(true)}
                        >
                            <QrCodeIcon />
                        </IconButton>
                    }
                })}


                <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center' }} onClick={() => window.location.href = "/"}>
                    <img src="./NV_PC_Sverige_h_color_rgb_negative@2x.png" alt="Logo" style={{ height: '30px' }} />
                </Typography>

                <IconButton
                    size="large"
                    edge="end"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                    onClick={toggleDrawer(true)}
                >
                    <MenuIcon />
                </IconButton>

                <Drawer anchor='right' open={isDrawerOpen} onClose={toggleDrawer(false)}>
                    <Box sx={{ width: 250 }} role="presentation">
                        <List>
                            <ListItem>
                                <Select
                                    value={i18n.language.split('-')[0]}
                                    onChange={handleLanguageChange}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    sx={{ width: '100%', mb: 1 }}
                                    size="small"
                                >
                                    <MenuItem value="sv">🇸🇪 Svenska</MenuItem>
                                    <MenuItem value="en">🇬🇧 English</MenuItem>
                                    <MenuItem value="de">🇩🇪 Deutsch</MenuItem>
                                </Select>
                            </ListItem>
                            <Divider />

                            {authContext && authContext.user.match({
                                loggedIn: (user) => (<>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar
                                                alt={user.profile.name}
                                                src={user.profile.picture}
                                                sx={{ width: 56, height: 56 }} // Adjust the size as needed
                                            />
                                        </ListItemAvatar>
                                        <ListItemText sx={{ ml: 2 }} primary={user.profile.name} secondary={"#" + (user.profile["membership_number"] as string | undefined ?? user.profile.preferred_username)} />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemButton>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch onChange={(evt) => eventContext.toggleDisplayAllEvents(evt.target.checked)} checked={eventContext.displayAllEvents} />} label={t("menu.show_all_activities")} />
                                            </FormGroup>
                                        </ListItemButton>
                                    </ListItem>
                                </>),
                                loggedOut: () => (
                                    <ListItem>
                                        <ListItemText primary={t("menu.not_logged_in")} />
                                    </ListItem>
                                )
                            })}

                            {authContext && authContext.user.match({
                                loggedIn(_) {
                                    return <ListItem>
                                        <ListItemButton onClick={() => setIsQrCodeModalOpen(true)}>
                                            <ListItemIcon>
                                                <QrCodeIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={t("menu.show_qr_code")} />
                                        </ListItemButton>
                                    </ListItem>
                                }
                            })}

                            <ListItem>
                                <ListItemButton onClick={() => setIsShareQrModalOpen(true)}>
                                    <ListItemIcon>
                                        <ShareIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={t("menu.share")} />
                                </ListItemButton>
                            </ListItem>

                            <ListItem>
                                <ListItemButton onClick={() => setIsInformationDialogOpen(true)}>
                                    <ListItemIcon>
                                        <InfoOutlineIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={t("menu.information")} />
                                </ListItemButton>
                            </ListItem>
                            <InformationDialog isOpen={isInformationDialogOpen} onClose={() => setIsInformationDialogOpen(false)} />

                            {authContext.user.match({
                                loggedIn: (_) =>
                                    <ListItem>
                                        <ListItemButton>
                                            <FormGroup>
                                                <FormControlLabel control={<WebPushSubscriptionSwitch />} label={t("menu.notifications")} />
                                            </FormGroup>
                                        </ListItemButton>
                                    </ListItem>
                            })}

                            <Divider />

                            {authContext.user.match({
                                loggedIn: (user) => user.requireMinimumPrivilege(PrivilegeValue.LocalStaff) &&
                                    <>
                                        <ListItem>
                                            <Typography>
                                                {t("menu.for_staff")}
                                            </Typography>
                                        </ListItem>

                                        <ListItem>
                                            <ListItemButton onClick={() => {
                                                navigate(constructCalendarUrlWithQuery(eventContext.calendarView, eventContext.displayAllEvents, eventContext.calendarDate));
                                                setIsDrawerOpen(false);
                                            }}>
                                                <ListItemIcon>
                                                    <CalendarMonthIcon />
                                                </ListItemIcon>
                                                <ListItemText primary={t("menu.calendar")} />
                                            </ListItemButton>
                                        </ListItem>

                                        <ListItem>
                                            <ListItemButton onClick={() => {
                                                navigate("/admin/banners");
                                                setIsDrawerOpen(false);
                                            }}>
                                                <ListItemIcon>
                                                    <OutlinedFlagIcon />
                                                </ListItemIcon>
                                                <ListItemText primary={t("menu.manage_banners")} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider />
                                    </>
                            })}

                            {authContext.user.match({
                                loggedIn: (user) => user.isInternalTester() &&
                                    <>
                                        <ListItem>
                                            <Typography>
                                                {t("menu.for_it_group")}
                                            </Typography>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemButton onClick={() => {
                                                navigate("/admin/notifications");
                                                setIsDrawerOpen(false);
                                            }}>
                                                <ListItemIcon>
                                                    <NotificationsOutlinedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary={t("menu.push_test")} />
                                            </ListItemButton>
                                        </ListItem>

                                        <ListItem>
                                            <ListItemButton onClick={() => {
                                                navigate("/admin/notify-event");
                                                setIsDrawerOpen(false);
                                            }}>
                                                <ListItemIcon>
                                                    <NotificationsOutlinedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary={t("menu.notify_activity")} />
                                            </ListItemButton>
                                        </ListItem>

                                        <ListItem>
                                            <ListItemButton>
                                                <FormGroup>
                                                    <FormControlLabel control={<Switch onChange={(evt) => eventContext.toggleShowPersonalEvents(evt.target.checked)} checked={eventContext.showPersonalEvents} />} label={t("menu.show_personal_activities")} />
                                                </FormGroup>
                                            </ListItemButton>
                                        </ListItem>

                                        {user.isDevAdmin() && (
                                            <ListItem>
                                                <Select
                                                    value={themeMode.mode}
                                                    onChange={handleThemeModeChange}
                                                    displayEmpty
                                                    inputProps={{ 'aria-label': 'Theme mode' }}
                                                    sx={{ width: '100%', mb: 1 }}
                                                    size="small"
                                                >
                                                    <MenuItem value="system">{t('menu.system')}</MenuItem>
                                                    <MenuItem value="light">{t('menu.light')}</MenuItem>
                                                    <MenuItem value="dark">{t('menu.dark')}</MenuItem>
                                                </Select>
                                            </ListItem>
                                        )}

                                        <Divider />
                                    </>
                            })}

                            <ListItem >
                                {authContext && authContext.user.match({
                                    loggedIn: (_) => (
                                        <ListItemButton onClick={async () => { await authContext!.logout(); }}>
                                            <ListItemIcon>
                                                <LogoutIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={t("menu.log_out")} />
                                        </ListItemButton>
                                    ),
                                    loggedOut: () => (
                                        <ListItemButton onClick={async () => { await authContext!.login(); }}>
                                            <ListItemIcon>
                                                <LoginIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={t("menu.log_in")} />
                                        </ListItemButton>
                                    )
                                })}
                            </ListItem>
                        </List>
                    </Box>
                </Drawer>
            </Toolbar>
            <QrCodeModal isOpen={isQrCodeModalOpen} onClose={toggleQrCodeModal(false)} />
            <ShareQrCodeModal isOpen={isShareQrModalOpen} onClose={() => setIsShareQrModalOpen(false)} />
            <SessionDidExpireModal />
            <WebPushPromptModal />
        </AppBar>
    )
};

const SessionDidExpireModal = () => {
    const authContext = useAuthContext();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        authContext.user.match({
            didExpire: () => setIsOpen(true)
        });
    }, [authContext.user]);

    return authContext.user.match({
        didExpire() {
            return <Dialog
                onClose={() => setIsOpen(false)}
                open={isOpen}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {t("session_expired.title")}
                </DialogTitle>
                <DialogCloseButton onClick={() => setIsOpen(false)} />
                <DialogContent dividers>
                    <Box>
                        <Typography component="p">{t("session_expired.message")}</Typography>
                        <p>{t("session_expired.ask_login")}</p>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => authContext.login()} variant="contained" >{t("session_expired.yes")}</Button>
                    <Button onClick={() => {
                        authContext.setUser(AuthenticationState.loggedOut());
                        navigate("/");
                    }} variant="outlined" >{t("session_expired.no")}</Button>
                </DialogActions>
            </Dialog>
        },
    });
}

const convertBase64UrlToBase64 = (base64url: string) => {
    base64url = base64url
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    var pad = base64url.length % 4;
    if (pad) {
        if (pad === 1) {
            throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
        }
        base64url += new Array(5 - pad).join('=');
    }

    return base64url;
}

const base64UrlToArrayBuffer = (base64url: string) => {
    const base64 = convertBase64UrlToBase64(base64url);
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export const pushAvaialble = () => "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window &&
    // modern browsers || safari
    (window.matchMedia("(display-mode: standalone)").matches || (window.navigator as any).standalone === true);

export const subscribeToWebPush = async (httpClientContext: any) => {
    const reg = await navigator.serviceWorker.ready;
    const existingSubscription = await reg.pushManager.getSubscription();
    const subscription = existingSubscription || await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: base64UrlToArrayBuffer("BJdMwXkpLFhbooP4D5xYe9Ei0LEX0IF4apm_hm8yrQ19o05fLTrGOOnvUUjg4X-TnFgahz3O5BbkX0nYoS32H5E")
    });

    return httpClientContext.authenticatedHttpClient.post("web-push/subscribe", {
        "subscription": subscription
    });
};

const WebPushPromptModal = () => {
    const authContext = useAuthContext();
    const httpClientContext = useHttpClientContext();
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isSubscribing, setIsSubscribing] = useState(false);

    useEffect(() => {
        const isPwa = window.matchMedia("(display-mode: standalone)").matches || (window.navigator as any).standalone === true;

        if (isPwa && localStorage.getItem("pwa_notification_prompted") !== "true") {
            localStorage.setItem("pwa_notification_pending", "true");
        }

        const shouldPrompt = localStorage.getItem("pwa_notification_pending") === "true"
            && localStorage.getItem("pwa_notification_prompted") !== "true";

        if (!shouldPrompt) return;
        if (!("serviceWorker" in navigator && "PushManager" in window && "Notification" in window)) return;

        authContext.user.match({
            loggedIn: async () => {
                const reg = await navigator.serviceWorker.ready;
                const permission = await reg.pushManager.permissionState({ userVisibleOnly: true });

                if (permission !== "granted" && permission !== "denied") {
                    setIsOpen(true);
                } else if (permission === "granted") {
                    const existingSubscription = await reg.pushManager.getSubscription();
                    if (!existingSubscription) {
                        setIsOpen(true);
                    }
                }
            }
        });
    }, [authContext.user]);

    const handleClose = (agreed: boolean) => {
        localStorage.setItem("pwa_notification_prompted", "true");
        localStorage.removeItem("pwa_notification_pending");

        if (agreed) {
            setIsSubscribing(true);
            subscribeToWebPush(httpClientContext)
                .then(() => {
                    console.debug("Successfully subscribed from prompt");
                })
                .catch((error: AxiosError) => {
                    if (error.status === 500) {
                        alert(t("web_push.error_alert"));
                    }
                    console.error("Error subscribing from prompt", error);
                })
                .finally(() => {
                    setIsSubscribing(false);
                    setIsOpen(false);
                });
        } else {
            setIsOpen(false);
        }
    };

    return (
        <Dialog
            onClose={() => handleClose(false)}
            open={isOpen}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {t("web_push_prompt.title")}
            </DialogTitle>
            <DialogCloseButton onClick={() => handleClose(false)} />
            <DialogContent dividers>
                <Box>
                    <Typography component="p">{t("web_push_prompt.message")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                        {t("web_push_prompt.info")}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose(true)} variant="contained" disabled={isSubscribing}>
                    {isSubscribing ? t("web_push_prompt.enabling") : t("web_push_prompt.yes")}
                </Button>
                <Button onClick={() => handleClose(false)} variant="outlined" disabled={isSubscribing}>
                    {t("web_push_prompt.no")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const WebPushSubscriptionSwitch = () => {

    const httpClientContext = useHttpClientContext();
    const { t } = useTranslation();

    const [isChecked, setIsChecked] = useState(false);
    const loading = useRef(false);

    useEffect(() => {
        initialCheckedState();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initialCheckedState = async () => {
        if (!pushAvaialble()) {
            return;
        }

        const reg = await navigator.serviceWorker.ready;
        const permission = await reg.pushManager.permissionState({ userVisibleOnly: true });

        if (permission !== "granted") {
            return;
        }

        const existingSubscription = await reg.pushManager.getSubscription();

        setIsChecked(existingSubscription != null);
    }

    const onToggle = async (evt: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {

        if (pushAvaialble()) {
            const reg = await navigator.serviceWorker.ready;

            const permission = await reg.pushManager.permissionState({ userVisibleOnly: true });

            console.log("permission", permission);
            if (checked && permission === "denied") {
                setIsChecked(false);
                alert(t("web_push.denied_alert"));
                return;
            }

            if (loading.current) {
                return;
            }

            setIsChecked(checked);
            loading.current = true;

            const existingSubscription = await reg.pushManager.getSubscription();

            if (checked) {

                try {
                    subscribeToWebPush(httpClientContext)
                        .then(data => {
                            console.debug("Successfully subscribed", data);
                            setIsChecked(true);
                        })
                        .catch((error: AxiosError) => {
                            if (error.status === 500) {
                                alert(t("web_push.error_alert"));
                                console.error("Error subscribing", error);
                                setIsChecked(false);
                            }
                        })
                        .finally(() => {
                            loading.current = false;
                        });
                }
                catch (error) {
                    console.log("Error subscribing", error);
                    setIsChecked(false);
                    loading.current = false;
                }
            } else {
                if (existingSubscription) {
                    existingSubscription.unsubscribe().then(_ => {
                        return httpClientContext.authenticatedHttpClient.post("web-push/unsubscribe", {
                            "endpoint": existingSubscription.endpoint
                        });
                    });
                }

                loading.current = false;
            }

        } else {
            alert(t("web_push.unsupported_alert"));
        }
    };

    return <Switch onChange={onToggle} checked={isChecked} />;
}

const QrCodeModal = ({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) => {
    const authContext = useAuthContext();
    const { t } = useTranslation();

    return authContext.user.match({
        loggedIn(user) {
            const membershipNumber = user.getMembershipNumber();
            const formattedUserId = user.getFormattedUserId();

            return <BootstrapDialog
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {t("qr_modal.title")}
                </DialogTitle>
                <DialogCloseButton onClick={onClose} />
                <DialogContent dividers>
                    <Box display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center">

                        <QRCode value={membershipNumber ?? formattedUserId} size={150} />
                        <Typography mt={1} variant="h5">{membershipNumber ?? formattedUserId}</Typography>
                    </Box>
                </DialogContent>
            </BootstrapDialog>
        },
    });
}

const ShareQrCodeModal = ({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) => {
    const { t } = useTranslation();
    const siteUrl = window.location.origin;

    return <BootstrapDialog
        onClose={onClose}
        aria-labelledby="share-qr-dialog-title"
        open={isOpen}
    >
        <DialogTitle sx={{ m: 0, p: 2 }} id="share-qr-dialog-title">
            {t("share_qr_modal.title")}
        </DialogTitle>
        <DialogCloseButton onClick={onClose} />
        <DialogContent dividers>
            <Box display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center">
                <QRCode value={siteUrl} size={150} />
                <Typography mt={1} variant="body2" color="textSecondary">{siteUrl}</Typography>
            </Box>
        </DialogContent>
    </BootstrapDialog>;
}

const InformationDialog = ({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return <Dialog
        onClose={onClose}
        open={isOpen}
    >
        <DialogTitle sx={{ m: 0, p: 2 }}>
            {t("info_dialog.title")}
        </DialogTitle>
        <DialogCloseButton onClick={onClose} />
        <DialogContent dividers>
            <Box>
                <h3>{t("info_dialog.how_it_works")}</h3>

                <p>{t("info_dialog.intro")}</p>
                <p>{t("info_dialog.not_logged_in_sees")}</p>
                <IconTextRow icon={<CheckIcon />}>
                    <p>{t("info_dialog.not_logged_in_point1")}</p>
                </IconTextRow>

                <p>{t("info_dialog.logged_in_sees")}</p>
                <IconTextRow icon={<CheckIcon />}>
                    <p>{t("info_dialog.logged_in_point1")}</p>
                </IconTextRow>

                <IconTextRow icon={<ToggleOnIcon />}>
                    <p>{t("info_dialog.logged_in_point2")}</p>
                </IconTextRow>

                <IconTextRow icon={<GroupsOutlinedIcon />}>
                    <p>{t("info_dialog.logged_in_point3")}</p>
                </IconTextRow>
                <IconTextRow icon={<QrCodeIcon />}>
                    <p>{t("info_dialog.logged_in_point4")}</p>
                </IconTextRow>

                <IconTextRow icon={<NotificationsOutlinedIcon />}>
                    <p>{t("info_dialog.logged_in_point5")}</p>
                </IconTextRow>

                <p>{t("info_dialog.click_activity_sees")}</p>
                <IconTextRow icon={<AccessTimeIcon />}>
                    <p>{t("info_dialog.click_point1")}</p>
                </IconTextRow>
                <IconTextRow icon={<MapOutlinedIcon />}>
                    <p>{t("info_dialog.click_point2")}</p>
                </IconTextRow>
                <IconTextRow icon={<InfoOutlineIcon />}>
                    <p>{t("info_dialog.click_point3")}</p>
                </IconTextRow>
                <IconTextRow icon={<PersonOutlinedIcon />}>
                    <p>{t("info_dialog.click_point4")}</p>
                </IconTextRow>
                <IconTextRow icon={<GroupsOutlinedIcon />}>
                    <p>{t("info_dialog.click_point5")}</p>
                </IconTextRow>

                <p>{t("info_dialog.color_coding")}</p>
                <IconTextRow icon={<CircleIcon />} iconColor={theme.palette.eventCategory.registered}>
                    <p>{t("info_dialog.color_green")}</p>
                </IconTextRow>
                <IconTextRow icon={<CircleIcon />} iconColor={theme.palette.eventCategory.partnerRegistered}>
                    <p>{t("info_dialog.color_orange")}</p>
                </IconTextRow>
                <IconTextRow icon={<CircleIcon />} iconColor={theme.palette.eventCategory.noBookingRequired}>
                    <p>{t("info_dialog.color_blue")}</p>
                </IconTextRow>
                <IconTextRow icon={<CircleIcon />} iconColor={theme.palette.eventCategory.notBooked}>
                    <p>{t("info_dialog.color_brown")}</p>
                </IconTextRow>
                <IconTextRow icon={<CircleIcon />} iconColor={theme.palette.eventCategory.personal}>
                    <p>{t("info_dialog.color_purple")}</p>
                </IconTextRow>

                <p>{t("info_dialog.navigation")}</p>

                <IconTextRow icon={<AddCircleIcon />}>
                    <p>{t("info_dialog.nav_point1")}</p>
                </IconTextRow>
                <IconTextRow icon={<TodayIcon />}>
                    <p>{t("info_dialog.nav_point2")}</p>
                </IconTextRow>
                <IconTextRow icon={<FormatListBulletedOutlinedIcon />}>
                    <p>{t("info_dialog.nav_point3")}</p>
                </IconTextRow>
                <IconTextRow icon={<ViewDayOutlinedIcon />}>
                    <p>{t("info_dialog.nav_point4")}</p>
                </IconTextRow>

                <IconTextRow icon={<ArrowForwardIcon />}>
                    <p>{t("info_dialog.nav_point5")}</p>
                </IconTextRow>

                <IconTextRow icon={<ArrowBackIcon />}>
                    <p>{t("info_dialog.nav_point6")}</p>
                </IconTextRow>
                <p>{t("info_dialog.nav_point7")}</p>

                {/* 
📋 En översikt av aktiviteter som inte kräver anmälan (kan dock kräva bokning via exempelvis hotell eller liknande).
Som inloggad ser du:
✔ Aktiviteter som du eller din partner är anmäld till.
✔ Vid större evenemang, som en festival, kan du via menyn aktivera "Visa alla aktiviteter" för att få en bredare översikt.
👥 Deltagarlistor där de finns tillgängliga samt aktiviteter du är anmäld till. (Vissa deltagare kan vara dolda om de valt det vid anmälan.)
🔳 Möjlighet att visa en QR-kod för ditt medlemsnummer.
Vid klick på en aktivitet får du mer information, såsom:
📍 Platsinformation.
📝 Aktivitetsbeskrivning.
🛑 Om anmälan krävs ser du information om både din egen och din ev partners anmälan.
👥 Deltagarlista (om den är tillgänglig, med vissa deltagare dolda om de valt det vid anmälan)
Färgkodning av aktiviteter:
🟢 Grön – Du är anmäld till aktiviteten.
🟠 Orange – Din partner är anmäld, men inte du själv.
🔵 Blå – Ingen anmälan till PCS (men eventuellt via exempelvis hotellet).
🟤 Brun – Du är inte bokad på aktiviteten.
🟣 Lila – Personligt funktionärsuppdrag.
Navigering och vyinställningar:
I plus-menyn nere till höger kan du:
➕ Hoppa till dagens datum.
📆 Växla mellan dags- och veckovy.
↔ Stega dag/vecka framåt och bakåt (på mobil kan du även svepa åt olika håll).
                
                */}
            </Box>
        </DialogContent>
    </Dialog>
}